export default "__VITE_ASSET__DFBkZO2q__"